function Timer(props) {
	let hours = props.date.getHours();
	let minutes = props.date.getMinutes();
	let seconds = props.date.getSeconds();

	return (<div className="status-item">Время: {hours}:{minutes}:{seconds}</div>);
}

export default Timer;